export default __webpack_public_path__ + "static/media/pdf.525bc9be.svg";